import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-android-app-dev',
  templateUrl: './android-app-dev.component.html',
  styleUrls: ['./android-app-dev.component.css']
})
export class AndroidAppDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/android-app-dev/android-app-dev.component.ts